import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  base: '/bangding',
  mode: 'history',
  routes: [
    {
      path: '/account-query',
      name: 'accountQuery',
      component: resolve => require(['@/views/account/query.vue'], resolve)
    },
    {
      path: '/userno',
      name: 'usernolist',
      component: resolve => require(['@/views/account/userno.vue'], resolve)
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js